import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { TitleXLarge500 } from '@nebula/global-styles';
import { tabletMin } from '../constants';

export const compareTableColumns = css`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  column-gap: ${rem(8)};

  @media ${({ theme }) => theme.media.smallDesktopMin} {
    column-gap: ${rem(24)};
  }
`;

export const planCardGridPlacement = css<{ $gridColumn: number }>`
  grid-column: ${({ $gridColumn }) => $gridColumn};
`;

export const TabletHeaderSpacer = styled.div`
  grid-column: 1;
  min-height: 0;

  @media ${({ theme }) => theme.media.smallDesktopMin} {
    display: none;
  }
`;

export const PageContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: ${rem(24)} ${rem(16)} ${rem(48)};
  font-family: 'Roboto', sans-serif;

  @media ${tabletMin} {
    padding: ${rem(32)} ${rem(24)} ${rem(48)};
  }

  @media ${({ theme }) => theme.media.smallDesktopMin} {
    max-width: ${rem(1056)};
    padding: ${rem(32)} 0 ${rem(64)};
  }
`;

export const CompareGrid = styled.div`
  width: 100%;

  @media ${tabletMin} {
    ${compareTableColumns}
  }
`;

export const PageTitle = styled(TitleXLarge500)<{ hasError: boolean }>`
  grid-column: 1 / -1;
  margin: ${rem(16)} 0 ${rem(8)};
  min-width: 0;
  margin-bottom: ${({ hasError }) => (hasError ? rem(8) : 0)};

  @media ${({ theme }) => theme.media.smallDesktopMin} {
    grid-column: 1 / -1;
    grid-row: 1;
    align-self: start;
    margin-top: ${rem(24)};
  }
`;

export const ErrorAlertRow = styled.div.attrs({ 'data-track-view': true })`
  grid-column: 1 / -1;
  width: 100%;
  margin-bottom: ${rem(16)};

  @media ${({ theme }) => theme.media.smallDesktopMin} {
    margin-bottom: ${rem(16)};
  }
`;
